import { render, staticRenderFns } from "./DontHaveClinic.vue?vue&type=template&id=d965f0b6&scoped=true"
import script from "./DontHaveClinic.vue?vue&type=script&lang=js"
export * from "./DontHaveClinic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d965f0b6",
  null
  
)

export default component.exports